exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logo[data-v-6caac0eb]{position:absolute;left:1.5rem}", ""]);

// exports
